import React from 'react';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import PublicPage, { SUPPORT_EMAIL, SUPPORT_PHONE, SUPPORT_HOURS } from './PublicPage';

// Public support page (linked from the Zoom Marketplace listing).
const Support = () => (
  <PublicPage title="Support" icon={<SupportAgentRoundedIcon sx={{ fontSize: 40, color: '#38bdf8' }} />}>
    <p>We answer every request within <strong>1 business day</strong>, usually the same day during support hours.</p>

    <table>
      <tbody>
        <tr><th>Email</th><td><a href={'mailto:' + SUPPORT_EMAIL + '?subject=ZPro%20Audio%20support'}>{SUPPORT_EMAIL}</a> — the fastest way to open a support case</td></tr>
        <tr><th>Phone</th><td><a href={'tel:' + SUPPORT_PHONE.replace(/[^+\d]/g, '')}>{SUPPORT_PHONE}</a></td></tr>
        <tr><th>Hours</th><td>{SUPPORT_HOURS}</td></tr>
        <tr><th>First response</th><td>Within 1 business day</td></tr>
        <tr><th>User guide</th><td><a href="/guide">Adding, using and removing ZPro Audio</a></td></tr>
      </tbody>
    </table>

    <h2>When you write to us, include</h2>
    <ul>
      <li>Your username and your organisation's name</li>
      <li>The app you were using (Android, Windows or web panel) and its version, shown on the login screen</li>
      <li>What you did, what you expected and what happened, with a screenshot if you can</li>
    </ul>

    <h2>Common questions</h2>
    <h3>The host app says "Zoom is disconnected for this account"</h3>
    <p>Your admin needs to log into the web panel and click <strong>Connect Zoom</strong>. See the <a href="/guide">user guide</a>.</p>
    <h3>A participant sees "Waiting for host"</h3>
    <p>Participants can join only once the host has started the room's meeting.</p>
    <h3>"Already signed in on another device"</h3>
    <p>Each participant account works on one phone. Ask your admin to reset the device in the web panel.</p>
    <h3>Privacy or data requests</h3>
    <p>Email us as above; see our <a href="/privacy_policy">privacy policy</a> for your rights.</p>
  </PublicPage>
);

export default Support;
